import { scrollAnimations } from '../library/scroll';
import { entranceAnimations } from '../library/entrance';
import { ongoingAnimations } from '../library/ongoing';
import { mouseAnimations } from '../library/mouse';
import { backgroundScrollAnimations } from '../library/backgroundScroll';
import { getCssUnits, getEasing } from '../utils';
import fastdom from 'fastdom';
function getElement(id, ownerDocument) {
  return id ? (ownerDocument || document).getElementById(id) : null;
}
function getDirection(effect) {
  const alternate = effect.alternate ? 'alternate' : '';
  return effect.reversed ? `${alternate ? `${alternate}-` : ''}reverse` : alternate || 'normal';
}
function getLength(length) {
  return `${length.value}${getCssUnits(length.type)}`;
}
function getRange(range, add, isEnd) {
  // according to the CSS spec if the end range is a <length> then it is calculated from the start of the named range
  // our model assumes that <length> in end range is calculated from the end of the named range
  return `${range.name || 'cover'} ${isEnd && range.offset.type !== 'percentage' ? `calc(100% + ${getLength(range.offset)}${add ? ` + ${add}` : ''})` : add ? `calc(${getLength(range.offset)} + ${add})` : getLength(range.offset)}`;
}
function getRanges(effect) {
  return {
    start: getRange(effect.startOffset, effect.startOffsetAdd),
    end: getRange(effect.endOffset, effect.endOffsetAdd, true)
  };
}
function measure(target) {
  return fn => fastdom.measure(() => fn(target));
}
function mutate(target) {
  return fn => fastdom.mutate(() => fn(target));
}
function getNamedEffect(animation) {
  if (animation.namedEffect) {
    const name = animation.namedEffect.type;

    // check each preset library for the named effect
    if (name in scrollAnimations) {
      return scrollAnimations[name];
    } else if (name in entranceAnimations) {
      return entranceAnimations[name];
    } else if (name in ongoingAnimations) {
      return ongoingAnimations[name];
    } else if (name in mouseAnimations) {
      return mouseAnimations[name];
    } else if (name in backgroundScrollAnimations) {
      return backgroundScrollAnimations[name];
    }
  } else if (animation.keyframeEffect) {
    const effect = animation_ => {
      const {
        name,
        keyframes
      } = animation_.keyframeEffect;
      return [{
        ...animation_,
        name,
        keyframes
      }];
    };
    return {
      web: effect,
      style: effect
    };
  } else if (animation.customEffect) {
    return animation_ => [{
      ...animation_,
      keyframes: []
    }];
  }
  return null;
}
function getEffectsData(animations, effectId) {
  // process each AnimationData object into a KeyframeEffect object
  return animations.map((effect, index) => {
    // prepare the KeyframeEffectOptions object
    const effectOptions = {
      fill: effect.fill,
      easing: getEasing(effect.easing),
      iterations: effect.iterations === 0 ? Infinity : effect.iterations || 1,
      composite: effect.composite,
      direction: getDirection(effect)
    };

    // if this is a TimeAnimation then set the duration and delay as time values
    if (effect.type.startsWith('Time')) {
      effectOptions.duration = effect.duration;
      effectOptions.delay = effect.delay || 0;
    } else {
      // if ViewTimeline is supported
      if (window.ViewTimeline) {
        // set duration to 'auto'
        effectOptions.duration = 'auto';
      } else {
        // if ViewTimeline not supported then put a 100ms value in duration get a progress we can easily relate to
        // we split the duration to 99.99ms and delay of 0.01ms to get the fill-mode effect working
        effectOptions.duration = 99.99;
        effectOptions.delay = 0.01;
      }
    }
    return {
      effect,
      options: effectOptions,
      id: effectId && `${effectId}-${index + 1}`,
      part: effect.part
    };
  });
}
export { getElement, getNamedEffect, getEffectsData, measure, mutate, getDirection, getLength, getRanges };
//# sourceMappingURL=common.js.map